import { createSelector } from 'reselect';
import { reduxKey } from './constants';
function getSlice(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getSession = createSelector(getSlice, (state)=>state);
